/* global jQuery, gform_ppcp_form_settings_strings */
import './utilities';

window.GFPPCPFeedSettings = null;

( function( $, strings ) {
	const formData = strings.form_data[ Object.keys(strings.form_data)[0] ];

	window.GFPPCPFeedSettings = {
		isLegacy: strings.is_legacy === 'true',
		showNotice: formData.show_notice === 'true',

		init() {
			this.prefix = this.isLegacy ? 'gaddon' : 'gform';
			this.fieldClassPrefix = this.isLegacy ? `gaddon-setting-row-` : `gform_setting_`;
			this.fields = this.getFieldCache();
			this.utils = window.GFPayPalCheckoutUtils;

			this.addEventListeners();
			this.toggleTrialFields();
			this.maybeDisplayInvalidPaymentMethodsNotice();
		},

		addEventListeners() {
			var feedSettings = window.GFPPCPFeedSettings;

			this.fields.setupFeeEnabled.on( 'change', function() {
				feedSettings.toggleTrialFields();
			} );
		},

		/**
		 * Get the jQuery cache of field objects.
		 *
		 * @return {Object} The field cache.
		 */
		getFieldCache() {
			var fields = {
				transactionType: $( `#transactionType` ),
				enabled: $( `#trial_enabled` ),
				recurringAmount: $( `#recurringAmount` ),
				price: $( `#${ this.fieldClassPrefix }trialPrice` ),
				period: $( `#${ this.fieldClassPrefix }trialPeriod` ),
				product: $( `#trialPrice_product` ),
				amount: $( `#trialPrice_amount` ),
				billingCycleUnit: $( `#billingCycle_unit` ),
				setupFeeEnabled: $( `#setupfee_enabled` ),
			};

			fields.periodUnit = fields.period.find( `#trialPeriod_unit` );
			fields.priceOptions = fields.product.find( 'option' );

			return fields;
		},

		/**
		 * Handle the toggling of trial fields.
		 */
		toggleTrialFields() {
			var priceFieldValue = this.fields.product.val();

			if ( this.fields.setupFeeEnabled.prop( 'checked' ) ) {
				this.fields.enabled.prop( 'checked', false );
			}

			if ( this.fields.enabled.prop( 'checked' ) ) {
				this.initTrialFields();
			} else {
				this.fields.price.hide();
				this.fields.period.hide();
			}

			switch ( priceFieldValue ) {
				case 'enter_amount':
					this.fields.amount.show();
					break;
				default:
					this.fields.amount.hide();
			}
		},

		/**
		 * Show all of the trial fields when the trial is enabled.
		 */
		initTrialFields() {
			this.fields.price.show();
			this.fields.period.show();
			this.fields.product.show();
		},

		/**
		 * Show the amount field if that option was selected among the trial price options..
		 */
		maybeShowAmountField() {
			if ( this.fields.price.find( 'option:selected' ).val() === 'enter_amount' ) {
				this.fields.amount.show();
			} else {
				this.fields.amount.hide();
			}
		},

		/**
		 * Exclude the product from the trial price dropdown if it is currently selected in the recurring amount field.
		 *
		 * Resets the trial price input to the free trial value if the trial price is set to a product and the
		 * admin subsequently selects the product as the recurring amount.
		 */
		updateTrialPriceOptions() {
			var recurringPrice = this.fields.recurringAmount.find( 'option:selected' ).val();
			var trialProduct = this.fields.product.find( `option[value="${ recurringPrice }"]` );

			this.fields.priceOptions.show();

			if ( ! trialProduct.length ) {
				return;
			}

			trialProduct.hide();

			if ( this.fields.product.find( `option:selected` ).val() === recurringPrice ) {
				this.fields.product.val( 'free_trial' );
			}
		},

		maybeDisplayInvalidPaymentMethodsNotice() {
			const container = this.fields.transactionType.closest( 'div' );

			if ( this.fields.transactionType.val() === 'subscription' && this.showNotice ) {
				container.append( this.utils.subscriptions.getUnsupportedPaymentMethodMarkup( this.isLegacy ) );
				return;
			}

			container.find( '#gf-paypal-checkout-unsupported-payment-warning' ).remove();
		},
	};

	$( document ).ready( function() {
		window.GFPPCPFeedSettings.init();
	} );
}( jQuery, gform_ppcp_form_settings_strings ) );
